import { Select, Spin } from "antd"
import React, { useState } from "react"
import { t } from "~/languages/i18n"
import logoEn from "../../../../public/images/logo-en.png"
import logoVi from "../../../../public/images/logo-vi.png"

interface LanguageItemComponentProps {
  onChange?: (value: string) => void
  defaultValue?: string
  isLoading?: boolean
  disable?: boolean
}

const LanguageItem: React.FC<LanguageItemComponentProps> = ({ onChange, defaultValue, isLoading, disable }) => {
  const [selectedLanguage, setSelectedLanguage] = useState(defaultValue)

  const handleChange = (value: any) => {
    setSelectedLanguage(value.value)
    onChange?.(value.value)
  }
  return (
    <div className={`border p-4 bg-white rounded-t-lg`}>
      <div className="flex items-center justify-between">
        <span className="text-base font-medium">{t("Choose Language")}</span>
        {isLoading ? (
          <div className="flex items-center gap-2">
            <Spin size="small" />
          </div>
        ) : (
          <>
            <Select
              labelInValue
              defaultValue={{ value: defaultValue }}
              onChange={handleChange}
              disabled={disable}
              options={[
                {
                  value: "vi",
                  label: (
                    <div className="flex items-center gap-2">
                      <img src={logoVi} alt="Vietnamese" className="w-5 h-5" />
                      VI
                    </div>
                  ),
                },
                {
                  value: "en",
                  label: (
                    <div className="flex items-center gap-2">
                      <img src={logoEn} alt="English" className="w-5 h-5" />
                      EN
                    </div>
                  ),
                },
              ]}
            />
          </>
        )}
      </div>
    </div>
  )
}

export default LanguageItem
